import React from 'react';


function UpcomingEvents() {
    return (
      <div class="home-container" style={{ padding:'40px' }}>
        <div class="card1"  >
            <div class="title">Upcoming Events</div>
            <div class="card-grid1">
          <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
            <h3>Sri Srinavasa Kalyanam</h3>
            <p class="p2">"Srinivasa Kalyanam" illustrates the sacred bond with another human through nuptial rituals and the sanctity of the institution of marriage</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>Brahmotsavam</h3>
            <p class="p2">"Srinivasa Kalyanam" illustrates the sacred bond with another human through nuptial rituals and the sanctity of the institution of marriage</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>Mahalakshmi Pooja</h3>
            <p class="p2">A special archana will be performed in the name of whole family or the name of the person and a special 
              Prasadam will be cooked by chanting veda mantras and the same will be distributed to all the devotees visited to the temple on that day.</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
          <h3>Vinayaka Chathurthi</h3>
            <p class="p2">Thirumanjanam will be performed to the desired deities on the request like Rudrabhishekam for lord Shiva, Hanuman Abhishekam, Sri Rama Abhishekam,
               Vishnu Abhishekam, Ganesha Abhishekam, Navagraha Abhishekam</p>
           </div>
          <div class="event-card" style={{ backgroundColor: '#F9E076' }}>
          <h3>YOGA HANUMAN PREMIER LEAGUE</h3>
          <p class="p2">YOGA HANUMAN PREMIER LEAGUE is a tennis ball cricket league conducted for charity. This is an open tournament and any team can participate 
            in this with a nominal participation fee. The money collected will be used for charity.</p>
            </div>
          <div class="event-card" style={{ backgroundColor: '#F5EB9A' }}>
          <h3>Vana Bhojanam</h3>
          <p class="p2">"Srinivasa Kalyanam" illustrates the sacred bond with another human through nuptial rituals and the sanctity of the institution of marriage</p><br></br>
            </div>
        </div>
      {/* Add page content */}
      </div>
    </div>
  );
};

export default UpcomingEvents;